// extracted by mini-css-extract-plugin
export default {"w-full":"Statements_w-full__ml6uJ","card":"Statements_card__a2Pt0"};